import { Component } from "@angular/core";
import { Router } from "@angular/router";
@Component({
    moduleId: module.id,
    template: `    
    <div>
    <h3 role="heading"><span>אישור הרשמה</span></h3>

    <div class="row">
        <ul class="msg-ul">
            <!-- successfull message -->
            <li class="msg success">
                <div role="alert">
                    <span class="fa-stack fa-lg">
                                        <i class="fa fa-stop fa-stack-2x" aria-hidden="true"></i>
                                        <i class="fa fa-check fa-stack-1x" aria-hidden="true"></i>
                                    </span>
                    <h3 class="msgg">
                        <span tabindex="-1">עדכון פרטים בוצע בהצלחה.</span>
                    </h3>
                </div>
            </li>
        </ul>
    </div>
    <div class="jumbotron ovedjumbo">
        <div class="row">
            <label class="control-label">עדכון הפרטים בוצע בהצלחה </label>
            
        </div>
        <div class="row">
            <label class="control-label">נהיה בקשר... </label>
        </div>
    </div>
    <div class="row wiz-footer-btn">
        <button type="button" class="btn btn-default btn-lg pull-left" (click)="endrishumClicked($event)"> סיום </button>
        <span class="nav-seperator" aria-hidden="true"></span>
        <a href="#" role="button" class="btn btn-link btn-lg pull-left" (click)="updateRishum($event)">לעדכון</a>
    </div>
</div>`
})

export class EndRishumComponent {
    constructor(private router: Router) { }

    endrishumClicked(event) {
        event.preventDefault();
        localStorage.removeItem("token");
        location.reload();
    }

    updateRishum(event) {
        event.preventDefault();
        this.router.navigateByUrl('/keep-in-touch');
    }

}